// extracted by mini-css-extract-plugin
module.exports = {"prompt":"Prompt_prompt__29ROc","wrapper":"Prompt_wrapper__1MSrT","message":"Prompt_message__3-txi","buttons":"Prompt_buttons__Umx_B"};